import axios from "axios";

//Create Duecollection
const createDueCollection = async (duecollection, token) => {
  const response = await axios.post(
    "/api/v1/passport/duecollection",
    duecollection,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data.data;
};

//Get All Duecollections
const getAllDueCollections = async (token) => {
  const response = await axios.get("/api/v1/passport/duecollection", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

//Get Duecollection By Id
const getDueCollectionById = async (id, token) => {
  const response = await axios.get(`/api/v1/passport/duecollection/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

//Update Duecollection
const updateDueCollection = async (id, duecollection, token) => {
  const response = await axios.patch(
    `/api/v1/passport/duecollection/${id}`,
    duecollection,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data.data;
};

//Delete Duecollection
const deleteDueCollection = async (id, token) => {
  const response = await axios.delete(`/api/v1/passport/duecollection/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

// Get Duecollections By Passport Id
const getDueCollectionsByPassportId = async (id, token) => {
  const response = await axios.get(
    `/api/v1/passport/duecollection/pass/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data.data;
};

const duecollectionService = {
  createDueCollection,
  getAllDueCollections,
  getDueCollectionById,
  updateDueCollection,
  deleteDueCollection,
  getDueCollectionsByPassportId,
};

export default duecollectionService;
